import { type CSSProperties, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as asyncJobActionsRaw from '../../redux/actions/asyncJobActions';
import { closeJobs } from '../../redux/actions/asyncJobActions';

// biome-ignore lint/suspicious/noExplicitAny: see note above
const asyncJobActions: any = asyncJobActionsRaw;

import AsyncJobs from './AsyncJobs';

// biome-ignore lint/suspicious/noExplicitAny: redux state + jsx child untyped
type AnyData = any;

// biome-ignore lint/suspicious/noExplicitAny: AsyncJobs is untyped .jsx
const AsyncJobsAny: any = AsyncJobs;

export interface AsyncJobsDialogProps {
  anchorEl?: HTMLElement | null;
}

const POPOVER: CSSProperties = {
  position: 'fixed',
  zIndex: 1400,
  background: 'var(--chakra-colors-bg)',
  color: 'var(--chakra-colors-fg)',
  borderRadius: 4,
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  minWidth: 320,
  maxWidth: 480,
  maxHeight: '70vh',
  overflow: 'auto',
};

const AsyncJobsDialog = ({ anchorEl }: AsyncJobsDialogProps) => {
  const { open, jobs, intervals } = useSelector((state: AnyData) => state.AsyncJob);
  const dispatch = useDispatch();
  const [rect, setRect] = useState<DOMRect | null>(null);

  useEffect(() => {
    const asyncEffect = async () => {
      if (open && !intervals.length) {
        dispatch(asyncJobActions.startCheckingJobs(dispatch, { startCheckTime: new Date() }));
      } else if (!open) {
        dispatch(asyncJobActions.stopCheckingJobs());
      }
    };
    asyncEffect().catch((err) => console.error(err));
  }, [open, intervals.length, dispatch]);

  useEffect(() => {
    setRect(anchorEl?.getBoundingClientRect() ?? null);
  }, [anchorEl]);

  if (!(anchorEl && open) || !rect) {
    return null;
  }

  const style: CSSProperties = {
    ...POPOVER,
    top: rect.bottom + 4,
    left: rect.left,
  };

  return (
    <>
      <button
        type="button"
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 1399,
          background: 'transparent',
          border: 'none',
          cursor: 'default',
          padding: 0,
        }}
        onClick={() => dispatch(closeJobs())}
        aria-label="close jobs popover"
      />
      <div style={style}>
        <AsyncJobsAny jobs={jobs} />
      </div>
    </>
  );
};

export default AsyncJobsDialog;
